import {
    clipboard,
    getCookie,
    initFileInput,
    setCookie,
    swalError,
    swalSuccessNoButton,
    swalSuccessWithButton
} from "./core";
import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import usersLocale from './i18n/users.json';
import Swal from "sweetalert2";

require('jquery.cookie');

class Users {

    // Autolock users
    autolock() {
        let $button = $('#button-auto-lock');
        let $form = $('#users-lock-form');
        let locale = getCookie('language-js');
        locale = (locale === null || locale === '') ? 'en_US' : locale;

        i18next.use(Backend)
            .init({
                lng: locale,
                resources: usersLocale
            });

        $button.click(function () {

            Swal.fire({
                title: i18next.t('confirm'),
                html: i18next.t('autolock'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ff7600',
                cancelButtonColor: '#999',
                confirmButtonText: i18next.t('confirm'),
                cancelButtonText: i18next.t('cancel')
            }).then((result) => {
                if (result.value) {
                    $button.button('loading');
                    $.ajax({
                        url: $form.attr('action'),
                        method: 'post',
                        dataType: 'json',
                        data: $('#users-lock-form').serialize()
                    }).done(function (json) {
                        swalSuccessNoButton(json);
                        $button.button('reset');
                        setTimeout(() => window.location.href = json.data.route, 1000);

                    }).fail(function (json) {
                        swalError(json);
                    }).always(function () {
                        $button.button('reset');
                    });
                }
            });
        });
    }

    // Register users from header
    headerRegister() {
        let $button = $('#header-register-user');
        let $form = $('#header-register-form');

        $button.click(() => {
            Users.register($button, $form);
        });

        $form.keypress(function (event) {
            if (event.keyCode === 13) {
                $button.click();
            }
        });
    }

    // Register users from form
    formRegister() {
        let $button = $('#register-user');
        let $form = $('#register-form');

        $button.click(() => {
            Users.register($button, $form);
        });

        $form.keypress(function (event) {
            if (event.keyCode === 13) {
                $button.click();
            }
        });

        $(function () {
            $('[data-toggle="tooltip"]').tooltip();

            $(document).on('input', '.form-templates-v5 .animation-label', function () {
                if($(this).val() && $(this).val().length > 0) {
                    $(this).addClass('active')
                } else {
                    $(this).removeClass('active')
                }
            })

            $.each($('.form-templates-v5 .animation-label'), function (inputIndex, inputValue) {
                if($(this).val() && ($(this).val()).length > 0) {
                    $(this).addClass('active')
                } else {
                    $(this).removeClass('active')
                }
            })

        })
    }

    // Last section
    lastURL(url) {
        setCookie('last-url', url, 365);
    }

    // Checkbox Register Disabled
    checkboxRegister() {
        $("input[type='checkBox']").change(function () {
            var len = $("input[type='checkBox']:checked").length;
            if (len == 0)
                $("button#register-user").prop("disabled", true);
            else
                $("button#register-user").removeAttr("disabled");
        });
        $("input[type='checkBox']").trigger('change');
    }

    // User panel
    panel(image) {
        $('[data-toggle="tooltip"]').tooltip();
        clipboard()
        initFileInput()
        this.autolock();
        this.paymentMethods();
        this.paymentsTransactions();
        this.sportsHistoryModal();
        this.storeClaims();
        this.storePaymentMethods();
        this.storeTransactions();
        this.updatePassword();
        this.updateProfile();
        //this.updateBonusStatus();
        this.changeCountry();
        this.walletTransactions();
        this.walletTransactionsPanel();
        this.storeDocument();
        this.storeImage(image);
        this.typeDocuments();
        this.referredFriends();
        this.updateToken();
        this.generateToken();
    }

    // Change Country
    changeCountry() {
        $(document).on('change', '.change-country', function () {
            let value = $(this).val();
            let route = $(this).data('route');
            $.ajax({
                url: route,
                type: 'post',
                dataType: 'json',
                data: {
                    payments_country: value
                }
            }).done(function (json) {
                setTimeout(() => {
                    swalSuccessNoButton(json);
                    window.location.href = json.data.route;
                }, 1500);

            }).fail(function (json) {
                swalError(json);
            });
        });
    }

    changeCountryCity(api, key, load, message) {
        $(document).on('change', '#country_iso', function () {
            let countrySelected = $(this).val()
            Users.cities(api, key, countrySelected, load, message);
        });
    }

    citySelection(api, key, load, message) {
        let countrySelected = $('#country_iso').val()
        Users.cities(api, key, countrySelected, load, message);
    }

    // Payment methods
    paymentMethods() {
        let $table = $('#payment-methods-table');

        $table.DataTable({
            "order": [],
            "columns": [
                {"data": "logo", "className": "d-sm-table-cell"},
                {"data": "info", "className": "d-md-table-cell"},
            ]
        });
    }

    // Payments transactions
    paymentsTransactions() {
        let $modal = $('#payments-transactions-modal');
        let $table = $('#payments-transactions-table');

        $modal.on('show.bs.modal', function () {
            $table.DataTable({
                "responsive": true,
                "bFilter": false,
                "bInfo": false,
                "ordering": false,
                "asStripeClasses": [''],
                "scrollCollapse": false,
                "info": false,
                "processing": false,
                "ajax": {
                    "url": $table.data('route'),
                    "dataSrc": "data.transactions"
                },
                "order": [],
                "columns": [
                    {"data": "date"},
                    {"data": "modified_amount", "className": "text-right d-sm-none"},
                    {"data": "description", "className": "d-none d-sm-table-cell"},
                    {"data": "debit", "className": "text-right d-none d-sm-table-cell"},
                    {"data": "credit", "className": "text-right d-none d-sm-table-cell"},
                    {"data": "status", "className": "text-right"}
                ],
                "initComplete": function () {
                    $('#payments-transactions-table-loader').hide();
                    $('#payments-transactions-table-container').show();
                }
            });
        });

        $modal.on('hide.bs.modal', function () {
            $table.DataTable().destroy();
        });
    }

    // Resend activation email
    resendActivationEmail() {
        let $button = $('#resend-activation-email');
        let $form = $('#resend-activation-form');

        $button.click(function () {
            $button.button('loading');
            $.ajax({
                url: $form.attr('action'),
                method: 'post',
                dataType: 'json',
                data: $form.serialize()

            }).done(json => {
                $form.trigger('reset');
                swalSuccessWithButton(json);

            }).fail(function (json) {
                swalError(json);

            }).always(function () {
                $button.button('reset');
            });
        });

        $form.keypress(function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                $button.click();
            }
        });
    }

    // Sports history transactions
    sportsHistoryModal() {
        let $modal = $('#sports-history-modal');
        let $table = $('#sports-history-table');
        let locale = getCookie('language-js');
        locale = (locale === null || locale === '') ? 'en_US' : locale;

        i18next.use(Backend)
            .init({
                lng: locale,
                resources: usersLocale
            });

        $modal.on('show.bs.modal', function () {
            $table.DataTable({
                "responsive": true,
                "bFilter": false,
                "bInfo": false,
                "ordering": false,
                "asStripeClasses": [''],
                "scrollCollapse": false,
                "info": false,
                "processing": false,
                "ajax": {
                    "url": $table.data('route'),
                    "dataSrc": "data.transactions"
                },
                "order": [],
                "columns": [
                    {
                        "className": 'details-control',
                        "orderable": false,
                        "data": null,
                        "defaultContent": ''
                    },
                    {"data": "date"},
                    {"data": "provider_transaction"},
                    {"data": "amount", "className": "text-right d-none d-sm-table-cell"}
                ],
                "initComplete": function () {
                    $('#sports-history-table-loader').hide();
                    $('#sports-history-table-container').show();
                }
            });

            $(document).on('click', '#sports-history-table tbody td.details-control', function () {
                let tr = $(this).closest('tr');
                let row = $table.DataTable().row(tr);

                if (row.child.isShown()) {
                    row.child.hide();
                    tr.removeClass('shown');
                } else {
                    row.child(function () {
                        let $div = $('<div/>').addClass('loading').text(i18next.t('loading'));

                        $.ajax({
                            url: $table.data('ticket-info-route') + '/' + row.data().provider_transaction,
                            type: 'get',
                            dataType: 'json'

                        }).done(function (json) {
                            $div.html(json.data.ticket).removeClass('loading');

                        }).fail(function (json) {
                            swalError(json);
                        });
                        return $div;
                    }).show();
                    tr.addClass('shown');
                }
            });
        });

        $modal.on('hidden.bs.modal', function () {
            $table.DataTable().destroy();
            $('#sports-history-table-loader').show();
            $('#sports-history-table-container').hide();
        });
    }

    // Store transactions
    storeClaims() {
        let $modal = $('#store-claims-modal');
        let $table = $('#store-claims-table');

        $modal.on('show.bs.modal', function () {
            $table.DataTable({
                "responsive": true,
                "bFilter": false,
                "bInfo": false,
                "ordering": false,
                "asStripeClasses": [''],
                "scrollCollapse": false,
                "info": false,
                "processing": false,
                "ajax": {
                    "url": $table.data('route'),
                    "dataSrc": "data.claims"
                },
                "order": [[0, "desc"]],
                "columns": [
                    {"data": "date"},
                    {"data": "name"},
                    {"data": "prize"},
                    {"data": "points"},
                ],
                "initComplete": function () {
                    $('#store-claims-table-loader').hide();
                    $('#store-claims-table-container').show();
                }
            });
        });

        $modal.on('hidden.bs.modal', function () {
            $table.DataTable().destroy();
            $('#store-claims-table-loader').show();
            $('#store-claims-table-container').hide();
        });
    }

    // Store image avatar
    storeImage(preview) {
        initFileInput(preview);

        var $button = $('#submit');
        var $form = $('#avatar-update-form');

        $form.on('submit', function (event) {
            event.preventDefault();
            var formData = new FormData(this);

            $button.button('loading');
            $.ajax({
                url: $form.attr('action'),
                type: 'post',
                dataType: 'json',
                contentType: false,
                processData: false,
                cache: false,
                data: formData

            }).done(function (json) {
                $('#file').val(json.data.file);
                swalSuccessNoButton(json);
                setTimeout(() => window.location.reload(), 1000);

            }).fail(function (json) {
                swalError(json);

            }).always(function () {
                $button.button('reset');
            });
        });
    }

    // Store Document for verification
    storeDocument() {
        initFileInput();

        let $button = $('#store-document');
        let $form = $('#document-verification-form');
        let $modal = $('#document-verifications-modal');

        $form.on('submit', function (event) {
            event.preventDefault();
            let formData = new FormData(this);

            $button.button('loading');
            $.ajax({
                url: $form.attr('action'),
                type: 'post',
                dataType: 'json',
                contentType: false,
                processData: false,
                cache: false,
                data: formData

            }).done(function (json) {
                $form.trigger('reset');
                swalSuccessNoButton(json);
                setTimeout(() => window.location.reload(), 1000);

            }).fail(function (json) {
                swalError(json);

            }).always(function () {
                $button.button('reset');
            });
        });

        $modal.on('show.bs.modal', function (event) {
            let $target = $(event.relatedTarget);
            $('#type').val($target.data('type'));
        })

        $form.keypress(function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                $button.click();
            }
        });
    }

    // Referred friends
    referredFriends() {
        let $table = $('#referred-friends-table');

        $table.DataTable({
            "scrollCollapse": false,
            "info": false,
            "processing": false,
            "ajax": {
                "url": $table.data('route'),
                "dataSrc": "data.users"
            },
            "order": [[0, "desc"]],
            "columns": [
                {"data": "date"},
                {"data": "username"},
                {"data": "deposit_amount", "className": "text-right"}
            ]
        });
    }

    // Type documents
    typeDocuments() {
        let $table = $('#documents-table');
        let $modal = $('#document-verifications-modal');

        $modal.on('show.bs.modal', function (event) {
            let $target = $(event.relatedTarget);
            let type = $target.data('type')
            $('#document_type').val(type);
        });


        $table.DataTable({
            "scrollCollapse": false,
            "info": false,
            "processing": false,
            "ajax": {
                "url": $table.data('route'),
                "dataSrc": "data.types"
            },
            "columns": [
                {"data": "document"},
                {"data": "document_status"},
                {"data": "button", "className": "text-right"}
            ]
        });
    }

    // Store payment methods
    storePaymentMethods(facebookPixel) {
        let $button = $('.store-payment-method');

        $('.store-payment-methods-form').keypress(function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        })

        $button.click(function () {
            let paymentMethod = $(this).data('payment-method');
            let $form = $('#store-payment-methods-form-' + paymentMethod);
            $button.button('loading');

            $.ajax({
                url: $form.attr('action'),
                method: 'post',
                data: $form.serialize()

            }).done(function (json) {
                $('#store-payment-methods-modal').modal('hide');

                if(json.data.route) {
                    swalSuccessWithButton(json, function () {
                        window.location.href = json.data.route;
                    });
                } else {
                    swalSuccessWithButton(json, function () {
                        window.location.reload();
                    });
                }

            }).fail(function (json) {
                swalError(json);

            }).always(function () {
                $button.button('reset');
            });
        });
    }

    // Store transactions
    storeTransactions() {
        let $modal = $('#store-transactions-modal');
        let $table = $('#store-transactions-table');

        $modal.on('show.bs.modal', function () {
            $table.DataTable({
                "responsive": true,
                "bFilter": false,
                "bInfo": false,
                "ordering": false,
                "asStripeClasses": [''],
                "scrollCollapse": false,
                "info": false,
                "processing": false,
                "ajax": {
                    "url": $table.data('route'),
                    "dataSrc": "data.transactions"
                },
                "order": [[0, "desc"]],
                "columns": [
                    {"data": "date", "type": "date"},
                    {"data": "provider"},
                    {"data": "modified_amount", "className": "text-right d-sm-none", "type": "num-fmt"},
                    {"data": "debit", "className": "text-right d-none d-sm-table-cell", "type": "num-fmt"},
                    {"data": "credit", "className": "text-right d-none d-sm-table-cell", "type": "num-fmt"},
                    {"data": "balance", "className": "text-right d-none d-sm-table-cell", "type": "num-fmt"},
                ],
                "initComplete": function () {
                    $('#store-transactions-table-loader').hide();
                    $('#store-transactions-table-container').show();
                }
            });
        });

        $modal.on('hidden.bs.modal', function () {
            $table.DataTable().destroy();
            $('#store-transactions-table-loader').show();
            $('#store-transactions-table-container').hide();
        });
    }

    // Update password
    updatePassword() {
        let $button = $('#update-password');
        let $form = $('#password-form');

        $button.click(function () {

            $.ajax({
                url: $form.attr('action'),
                method: 'post',
                data: $form.serialize()

            }).done(function (json) {
                $form.trigger('reset');
                swalSuccessWithButton(json);

            }).fail(function (json) {
                swalError(json);

            }).always(function () {
                $button.button('reset');
            });
        });
    };

    // Update profile
    updateProfile() {
        let $button = $('#update-profile');
        let $form = $('#profile-form');

        $button.click(function () {
            $button.button('loading');

            $.ajax({
                url: $form.attr('action'),
                method: 'post',
                data: $form.serialize()

            }).done(function (json) {
                setTimeout(() => {
                    swalSuccessNoButton(json);
                    window.location.href = json.data.route;
                }, 1500);

            }).fail(function (json) {
                swalError(json);

            }).always(function () {
                $button.button('reset');
            });
        });
    };

    // Update phone token
    updateToken() {
        let $button = $('#validate-token');
        let $form = $('#validate-phone-form');

        $button.click(function () {
            $button.button('loading');

            $.ajax({
                url: $form.attr('action'),
                method: 'post',
                data: $form.serialize()

            }).done(function (json) {
                setTimeout(() => {
                    swalSuccessNoButton(json);
                    window.location.href = json.data.route;
                }, 1500);

            }).fail(function (json) {
                swalError(json);

            }).always(function () {
                $button.button('reset');
            });
        });
    };

    // Update profile
    generateToken() {
        let $button = $('#generate-token');
        let $form = $('#generate-token-form');

        $button.click(function () {
            $button.button('loading');

            $.ajax({
                url: $form.attr('action'),
                method: 'post',
                data: $form.serialize()

            }).done(function (json) {
                swalSuccessWithButton(json);

            }).fail(function (json) {
                swalError(json);

            }).always(function () {
                $button.button('reset');
            });
        });
    }



    // Update user bonus status to allow get bonuses
    /*updateBonusStatus() {
        $('#bonus-active').change(function() {
            let value;

            if(this.checked) {
                value = false;
            } else {
                value = true;
            }
            let route = $(this).data('route');
            $.ajax({
                url: route,
                type: 'post',
                dataType: 'json',
                data: {
                    bonus_status: value
                }
            }).done(function (json) {
                swalSuccessNoButton(json)
            })
        });
    }*/

    // Wallet transactions
    walletTransactions() {
        let $modal = $('#wallet-modal');
        let $table = $('#wallet-table');

        $modal.on('show.bs.modal', function () {
            $table.DataTable({
                "responsive": true,
                "bFilter": false,
                "bInfo": false,
                "asStripeClasses": [''],
                "scrollCollapse": false,
                "info": false,
                "processing": false,
                "ajax": {
                    "url": $table.data('route'),
                    "dataSrc": "data.transactions"
                },
                "order": [[1, "desc"]],
                "columns": [
                    {"data": "date"},
                    {"data": "id"},
                    {"data": "provider"},
                    {"data": "modified_amount", "className": "text-right d-sm-none", "type": "num-fmt"},
                    {"data": "description"},
                    {"data": "debit", "className": "text-right d-none d-sm-table-cell", "type": "num-fmt"},
                    {"data": "credit", "className": "text-right d-none d-sm-table-cell", "type": "num-fmt"},
                ],
                "initComplete": function () {
                    $('#wallet-table-loader').hide();
                    $('#wallet-table-container').show();
                }
            });
        });

        $modal.on('hidden.bs.modal', function () {
            $table.DataTable().destroy();
            $('#wallet-table-loader').show();
            $('#wallet-table-container').hide();
        });
    }

    // Wallet transactions UserPanel
    walletTransactionsPanel() {
        let $table = $('#wallet-panel');

        $table.DataTable({
            "scrollCollapse": false,
            "info": false,
            "processing": false,
            "ajax": {
                "url": $table.data('route'),
                "dataSrc": "data.transactions"
            },
            "lengthMenu": [3, 5],
            "order": [[1, "desc"]],
            "columns": [
                {"data": "date"},
                {"data": "id"},
                {"data": "provider"},
                {"data": "modified_amount", "className": "text-right d-sm-none", "type": "num-fmt"},
                {"data": "description"},
                {"data": "debit", "className": "text-right d-none d-sm-table-cell", "type": "num-fmt"},
                {"data": "credit", "className": "text-right d-none d-sm-table-cell", "type": "num-fmt"},
            ],
        });
    }

    // Register users
    static register($button, $form) {
        $button.button('loading');
        $.ajax({
            url: $form.attr('action'),
            method: 'post',
            dataType: 'json',
            data: $form.serialize()

        }).done(json => {
            $form.trigger('reset');

            if (json.data.route === undefined) {
                swalSuccessWithButton(json);

            } else {
                swalSuccessNoButton(json);
                setTimeout(() => window.location.href = json.data.route, 1000);
            }

        }).fail(function (json) {
            swalError(json);

        }).always(function () {
            $button.button('reset');
        });
    }

    static cities(api, key, countrySelected, load, message) {
        var cities = []
        $('#city').html('')
        $('#city').append(`'<option value="">${load}</option>'`)
        var configCities = {
            method: 'get',
            url: `${api}/countries/${countrySelected}/cities`,
            headers: {
                'X-CSCAPI-KEY': `${key}`,
            }
        };
        axios(configCities)
            .then(function (response) {
                $('#city').html('')
                $('#city').append(`'<option value="">${message}</option>'`)

                cities = response.data

                if (countrySelected !== '') {
                    $.each(cities, function (cityIndex, cityValue) {
                        $('#city').append(`<option value="${cityValue.name}">${cityValue.name}</option>`)
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
}

window.Users = Users;
